module.exports = {"140726100":"明星镇","140726101":"胡村镇","140726102":"范村镇","140726200":"侯城乡","140726201":"北汪乡","140726202":"水秀乡","140726203":"阳邑乡","140726204":"小白乡","140726205":"任村乡","140726401":"白塔区","140726402":"北城区","140726403":"南城区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140726.json
// module id = 416
// module chunks = 0